import { ShouldRevalidateFunctionArgs } from "react-router";
import { propagate404 } from "~/lib/api/response-helpers.server";
import { EcosystemV1 } from "~/lib/api/ecosystemV1.server";
import type { Route } from "./+types/SportData";

export function shouldRevalidate({
    currentParams,
    nextParams,
    defaultShouldRevalidate,
}: ShouldRevalidateFunctionArgs) {
    if (currentParams.sportSlug === nextParams.sportSlug) {
        return false;
    }
    return defaultShouldRevalidate;
}
export async function loader({ params }: Route.LoaderArgs) {
    const [
        {
            data: { result: sport },
        },
    ] = await Promise.all([EcosystemV1.GetSport(params.sportSlug).catch(propagate404())]);
    return { sport };
}
